import { render, staticRenderFns } from "./PromoCode.vue?vue&type=template&id=2ebb376c&scoped=true&"
import script from "./PromoCode.vue?vue&type=script&lang=js&"
export * from "./PromoCode.vue?vue&type=script&lang=js&"
import style0 from "./PromoCode.vue?vue&type=style&index=0&id=2ebb376c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebb376c",
  null
  
)

export default component.exports